import React from "react";
import {
  TextInput,
  TextArea,
  RequiredCheckbox,
  StepHeader,
} from "../activity-components/FormComponents";
import { StepProps, ActivityFormProps } from "../types";

type Props = StepProps &
  Pick<
    ActivityFormProps,
    "descriptionOfTab4" | "newsletterOptInText" | "agreePublishText"
  > & {
    onChange: (
      k: keyof import("../types").FormState,
    ) => (e: React.ChangeEvent<any>) => void;
  };

export function Step4({
  data,
  validationErrors,
  clearValidationError,
  stepFocusRef,
  descriptionOfTab4,
  newsletterOptInText,
  agreePublishText,
  onChange,
  onBlur,
  setData,
}: Props) {
  return (
    <>
      <StepHeader
        focusRef={stepFocusRef}
        ariaLabel="Steg 4: Kontakt"
        description={descriptionOfTab4}
      />

      <TextInput
        label="Kontakt e-post"
        value={data.contactEmail}
        onChange={(e) => {
          onChange("contactEmail")(e);
          clearValidationError("contactEmail");
        }}
        onBlur={onBlur("contactEmail")}
        type="email"
        required
        id="contactEmail"
        helpText="Dessa uppgifter används för kontakt med Trygg start-teamet och publiceras inte på Rörelseguiden."
        hasError={validationErrors.has("contactEmail")}
        errorMessage={
          !data.contactEmail
            ? "Fältet är obligatoriskt."
            : "Fältet måste innehålla en giltig e-postadress."
        }
      />

      <TextArea
        label="Kommentar till publicerare"
        value={data.contactComment}
        onChange={onChange("contactComment")}
        rows={5}
      />

      <RequiredCheckbox
        id="newsletterOptIn"
        checked={!!data.newsletterOptIn}
        onChange={(checked) => {
          setData((s) => ({ ...s, newsletterOptIn: checked }) as any);
          clearValidationError("newsletterOptIn");
        }}
        onBlur={onBlur("newsletterOptIn")}
        hasError={validationErrors.has("newsletterOptIn")}
        label={newsletterOptInText?.replace(/<\/?p>/g, "")}
      ></RequiredCheckbox>

      <RequiredCheckbox
        id="agreePublish"
        checked={!!data.agreePublish}
        onChange={(checked) => {
          setData((s) => ({ ...s, agreePublish: checked }) as any);
          clearValidationError("agreePublish");
        }}
        onBlur={onBlur("agreePublish")}
        hasError={validationErrors.has("agreePublish")}
        label={
          agreePublishText && (
            <span
              dangerouslySetInnerHTML={{
                __html: agreePublishText?.replace(/<\/?p>/g, ""),
              }}
            />
          )
        }
      ></RequiredCheckbox>
    </>
  );
}
